import React, { useState } from 'react';
import { StageBadge } from '../components/StageBadge';
import { ViewToggle, type ViewMode } from '../components/ViewToggle';
import { LeadModal } from '../components/LeadModal';
import { useLeads } from '../contexts/LeadsContext';
import { formatAmount, leadStages, type Lead } from '../data/mockData';
const filters = ['All', 'New', 'Contacting', 'Engaged', 'App Started'] as const;
export function Leads() {
  const [active, setActive] = useState<(typeof filters)[number]>('All');
  const [view, setView] = useState<ViewMode>('list');
  const [selected, setSelected] = useState<Lead | null>(null);
  const {
    leads: queue
  } = useLeads();
  const rows = active === 'All' ? queue : queue.filter(lead => lead.stage === active);
  return <div className="space-y-4" data-id="element-270" data-mp="31qa1boqi2tyk">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-271" data-mp="249utdtppuj05">
        <div data-id="element-272" data-mp="247h1ftqc1mwt">
          <h1 className="text-[22px] font-bold text-ink" data-id="element-273" data-mp="247qob8g2zdya">Leads</h1>
          <p className="mt-1 text-[13px] text-gray-500" data-id="element-274" data-mp="2973dw0yc6z4k">
            {queue.length} leads in your working list · in-process loans live in their own
            list
          </p>
        </div>
        <ViewToggle value={view} onChange={setView} data-id="element-275" data-mp="3sdu77h7yocc4" />
      </div>

      {view === 'list' && <div className="flex flex-wrap gap-2" role="group" aria-label="Lead filters" data-id="element-276" data-mp="3nl9e6hwvq39n">
          {filters.map(filter => <button key={filter} type="button" aria-pressed={active === filter} onClick={() => setActive(filter)} className={['rounded-full border px-3.5 py-1.5 text-[12.5px] font-medium transition-colors', active === filter ? 'border-brand bg-brand text-white' : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50'].join(' ')} data-id="element-277" data-mp="3jiw9lwtvcbeg">
              {filter}
            </button>)}
        </div>}

      {view === 'list' ? <div className="overflow-hidden rounded-xl border border-gray-200 bg-white" data-id="element-278" data-mp="ysx7i3zi8wjr">
          <table className="w-full text-left" data-id="element-279" data-mp="2sbdyb1u0oscp">
            <thead className="border-b border-gray-200 bg-gray-50 text-[11px] uppercase tracking-wider text-gray-500" data-id="element-280" data-mp="2x4gu7gm9odw2">
              <tr data-id="element-281" data-mp="2je3m9e9dkz6q">
                <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-282" data-mp="2jen6j1mhzznx">Borrower</th>
                <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-283" data-mp="2nf72w2z8yz90">Loan amount</th>
                <th scope="col" className="hidden px-5 py-2.5 font-semibold md:table-cell" data-id="element-284" data-mp="3b51dedw3gbq3">
                  Next step
                </th>
                <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-285" data-mp="3g0yskgvmfc1a">Stage</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-[13px]" data-id="element-286" data-mp="372d3s3zk30s2">
              {rows.map(lead => <tr key={lead.id} onClick={() => setSelected(lead)} className="cursor-pointer hover:bg-gray-50" data-id="element-287" data-mp="1qoekuzsr6x4l">
                  <td className="px-5 py-3" data-id="element-288" data-mp="1vkvajyflpjjs">
                    <div className="font-semibold text-ink" data-id="element-289" data-mp="1n5617ncsqw1w">{lead.name}</div>
                    <div className="text-[12px] text-gray-500" data-id="element-290" data-mp="1j559x24lmqdf">
                      {lead.state} · {lead.source}
                    </div>
                  </td>
                  <td className="px-5 py-3 text-ink" data-id="element-291" data-mp="1x2am7juwolh4">{formatAmount(lead.amount)}</td>
                  <td className="hidden px-5 py-3 text-gray-500 md:table-cell" data-id="element-292" data-mp="1s63fhouor5y4">
                    {lead.detail}
                  </td>
                  <td className="px-5 py-3" data-id="element-293" data-mp="zgwiwveskqfi">
                    <StageBadge stage={lead.stage} data-id="element-294" data-mp="zhxy9c2ubz31" />
                  </td>
                </tr>)}
            </tbody>
          </table>
          {rows.length === 0 && <p className="px-5 py-10 text-center text-[13px] text-gray-500" data-id="element-295" data-mp="19drfv9vf2iro">
              No leads in this stage right now.
            </p>}
        </div> : <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4" data-id="element-296" data-mp="gqn6ytt7dkam">
          {leadStages.map(stage => {
        const items = queue.filter(lead => lead.stage === stage);
        return <section key={stage} className="rounded-xl bg-gray-100/70 p-2.5" data-id="element-297" data-mp="3l2ftrleqegoq">
                <header className="flex items-center justify-between px-1 pb-2" data-id="element-298" data-mp="3p52ktk3kvxkv">
                  <h2 className="text-[12px] font-semibold text-ink" data-id="element-299" data-mp="3tvj0lauvfvae">{stage}</h2>
                  <span className="text-[11.5px] text-gray-500" data-id="element-300" data-mp="3txndujenu6nc">{items.length}</span>
                </header>
                <div className="space-y-2" data-id="element-301" data-mp="2rlyhynnwqvw">
                  {items.map(lead => <button key={lead.id} type="button" onClick={() => setSelected(lead)} className="w-full rounded-xl border border-gray-200 bg-white p-3.5 text-left transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-brand/30" data-id="element-302" data-mp="7qffi125r00t">
                      <p className="truncate text-[13px] font-semibold text-ink" data-id="element-303" data-mp="2ihfboj354xc7">
                        {lead.name}
                      </p>
                      <p className="text-[11.5px] text-gray-500" data-id="element-304" data-mp="2aypj238jtgzl">
                        {lead.state} · {lead.source}
                      </p>
                      <p className="mt-2 text-[13px] font-medium text-ink" data-id="element-305" data-mp="2169x6uu4s89f">
                        {formatAmount(lead.amount)}
                      </p>
                      <p className="mt-1.5 line-clamp-2 text-[11.5px] text-gray-500" data-id="element-306" data-mp="1x3n4ystjslbp">
                        {lead.detail}
                      </p>
                    </button>)}
                  {items.length === 0 && <p className="rounded-lg border border-dashed border-gray-300 px-3 py-6 text-center text-[11.5px] text-gray-400" data-id="element-307" data-mp="2ku98q7wirjfw">
                      Empty
                    </p>}
                </div>
              </section>;
      })}
        </div>}

      <LeadModal lead={selected} onClose={() => setSelected(null)} data-id="element-308" data-mp="14gj5129bax6s" />
    </div>;
}